
const productTypeLists = [
  {
      value: 1,
      text_en: 'Raw Material',
      text_bn: 'কাঁচামাল'
  },
  {
      value: 2,
      text_en: 'Finish Good',
      text_bn: 'ফিনিশ গুড'
  }
]

const burnPatientTypeList = [
    {
        value: 1,
        text: 'এসিড দগ্ধ',
        text_bn: 'এসিড দগ্ধ',
        text_en: 'Acid Burn'
    },
    {
        value: 2,
        text: 'দুর্ঘটনাজনিত কারণে দগ্ধ',
        text_bn: 'দুর্ঘটনাজনিত কারণে দগ্ধ',
        text_en: 'Accidental Burn'
    }
]
const splCategoryList = [
    {
        value: 1,
        text_en: 'Disabled students/poor and meritorious students',
        text_bn: 'প্রতিবন্ধী শিক্ষার্থী/দরিদ্র মেধাবী শিক্ষার্থী'
    },
    {
        value: 2,
        text_en: 'Distressed, helpless, sick, disabled, homeless individuals or organizations',
        text_bn: 'দুস্থ, অসহায়, অসুস্থ, প্রতিবন্ধী, গৃহহীন ব্যক্তি বা সংগঠন'
    }
]

const serviceTypeList = [
  {
      value: 1,
      text_en: 'Grant',
      text_bn: 'অনুদান'
  },
  {
      value: 2,
      text_en: 'Allowance',
      text_bn: 'ভাতা'
  },
  {
    value: 3,
    text_en: 'Stipend',
    text_bn: 'উপবৃত্তি'
  }
]

const healthConditionList = [
    {
        value: 1,
        text: 'Good',
        text_en: 'Good',
        text_bn: 'ভালো'
    },
    {
        value: 2,
        text: 'Roughly',
        text_en: 'Roughly',
        text_bn: 'মোটামুটি'
    },
    {
        value: 3,
        text: 'Bad',
        text_en: 'Bad',
        text_bn: 'খারাপ'
    }
]

const installmentList = [
    {
        value: 1,
        text: '1st installment',
        text_en: '1st installment',
        text_bn: '১ম কিস্তি'
    },
    {
        value: 2,
        text: '2nd instalment',
        text_en: '2nd instalment',
        text_bn: '২য় কিস্তি'
    }
]

const studentClassList = [
    {
        value: 1,
        text: 'Primary/Equivalent',
        text_en: 'Primary/Equivalent',
        text_bn: 'প্রাথমিক/সমমান'
    },
    {
        value: 2,
        text: 'Secondary/Equivalent',
        text_en: 'Secondary/Equivalent',
        text_bn: 'মাধ্যমিক/সমমান'
    },
    {
        value: 3,
        text: 'Higher Secondary/Equivalent',
        text_en: 'Higher Secondary/Equivalent',
        text_bn: 'উচ্চ মাধ্যমিক/সমমান'
    },
    {
        value: 4,
        text: 'Others',
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]

const studyingClassList = [
    {
        value: 18,
        class_id: 1,
        text: 'Nazera',
        text_en: 'Nazera',
        text_bn: 'নাজেরা'
    },
    {
        value: 19,
        class_id: 1,
        text: 'Hifoz Nazera',
        text_en: 'Hifoz Nazera',
        text_bn: 'হিফজ নাজেরা'
    },
    {
        value: 14,
        class_id: 1,
        text: 'Hifzo',
        text_en: 'Hifzo',
        text_bn: 'হিফজ'
    },
    {
        value: 16,
        class_id: 1,
        text: 'Sishu',
        text_en: 'Sishu',
        text_bn: 'শিশু'
    },
    {
        value: 17,
        class_id: 1,
        text: 'Kg',
        text_en: 'Kg',
        text_bn: 'কেজি'
    },
    {
        value: 1,
        class_id: 1,
        text: '1st Class (General) / Ebtedayi-1st (Dakhil) / First Class Noorani (Qaumi)',
        text_en: '1st Class (General) / Ebtedayi-1st (Dakhil) / First Class Noorani (Qaumi)',
        text_bn: 'প্রথম শ্রেণী (সাধারণ) / এবতেদায়ী-১ম (দাখিল) / প্রথম শ্রেণী নূরাণী (কাওমি)'
    },
    {
        value: 2,
        class_id: 1,
        text: '2nd Class (General) / Ebtedayi-2nd (Dakhil) / 2nd Class Noorani (Qaumi)',
        text_en: '2nd Class (General) / Ebtedayi-2nd (Dakhil) / 2nd Class Noorani (Qaumi)',
        text_bn: 'দ্বিতীয় শ্রেণী (সাধারণ) / এবতেদায়ী-২য় (দাখিল) / দ্বিতীয় শ্রেণী নূরাণী (কাওমি)'
    },
    {
        value: 3,
        class_id: 1,
        text: '3rd Class (General) / Ebtedayi-3rd (Dakhil) / 2nd Class Noorani (Qaumi)',
        text_en: '3rd Class (General) / Ebtedayi-3rd (Dakhil) / 2nd Class Noorani (Qaumi)',
        text_bn: 'তৃতীয় শ্রেণী (সাধারণ) / এবতেদায়ী-৩য় (দাখিল) / দ্বিতীয় শ্রেণী নূরাণী (কাওমি)'
    },
    {
        value: 4,
        class_id: 1,
        text: '4th Class (General) / Ebtedayi-4th (Dakhil) / Urdu Qaida Jamaat (Qaumi)',
        text_en: '4th Class (General) / Ebtedayi-4th (Dakhil) / Urdu Qaida Jamaat (Qaumi)',
        text_bn: 'চতুর্থ শ্রেণী (সাধারণ) / এবতেদায়ী-৪র্থ (দাখিল) / উর্দু কায়দা জামাত (কাওমি)'
    },
    {
        value: 5,
        class_id: 1,
        text: '5th Class (General) / Ebtedayi-5th (Dakhil) / Tahsi Jamaat (Qaumi)',
        text_en: '5th Class (General) / Ebtedayi-5th (Dakhil) / Tahsi Jamaat (Qaumi)',
        text_bn: 'পঞ্চম শ্রেণী (সাধারণ) / এবতেদায়ী-৫ম (দাখিল) / তাহসীর জামাত (কাওমি)'
    },
    {
        value: 6,
        class_id: 2,
        text: '6th Class (General) / Dakhil-6th (Dakhil) / Meezan Jamaat (Qaumi)',
        text_en: '6th Class (General) / Dakhil-6th (Dakhil) / Meezan Jamaat (Qaumi)',
        text_bn: 'ষষ্ঠ শ্রেণী (সাধারণ) / দাখিল-৬ষ্ট (দাখিল) / মীযান জামাত (কাওমি)'
    },
    {
        value: 7,
        class_id: 2,
        text: '7th Class (General) / Dakhil-7th (Dakhil) / Nahremi Jamaat (Qaumi)',
        text_en: '7th Class (General) / Dakhil-7th (Dakhil) / Nahremi Jamaat (Qaumi)',
        text_bn: 'সপ্তম শ্রেণী (সাধারণ) / দাখিল-৭ম (দাখিল) / নাহরেমীর জামাত (কাওমি)'
    },
    {
        value: 8,
        class_id: 2,
        text: '8th Class (General) / Dakhil-8th (Dakhil) / Hedayatunnah (Qaumi)',
        text_en: '8th Class (General) / Dakhil-8th (Dakhil) / Hedayatunnah (Qaumi)',
        text_bn: 'অষ্টম শ্রেণী (সাধারণ) / দাখিল-৮ম (দাখিল) / হেদায়াতুন্নাহ (কাওমি)'
    },
    {
        value: 9,
        class_id: 2,
        text: '9th Class (General) / Dakhil- 9th (Dakhil) / Kafia (Qaum)',
        text_en: '9th Class (General) / Dakhil- 9th (Dakhil) / Kafia (Qaum)',
        text_bn: 'নবম শ্রেণী (সাধারণ) / দাখিল- ৯ম (দাখিল) / কাফিয়া (কাওমি)'
    },
    {
        value: 10,
        class_id: 2,
        text: '10th Class (General) / Dakhil- 10th (Dakhil) / Sharhe Jami (Qaumi)',
        text_en: '10th Class (General) / Dakhil- 10th (Dakhil) / Sharhe Jami (Qaumi)',
        text_bn: 'দশম শ্রেণী (সাধারণ) / দাখিল- ১০ম (দাখিল) / শরহে জামী (কাওমি)'
    },
    {
        value: 11,
        class_id: 3,
        text: '11th Class (General) / Alim-1st Year (Dakhil) / Sharhe Bekaya (Qaum)',
        text_en: '11th Class (General) / Alim-1st Year (Dakhil) / Sharhe Bekaya (Qaum)',
        text_bn: 'একাদশ শ্রেণী (সাধারণ) / আলিম-১ম বর্ষ (দাখিল) / শরহে বেকায়া (কাওমি)'
    },
    {
        value: 12,
        class_id: 3,
        text: '12th Class (General) / Alim-2nd Year (Dakhil) / Jalalain (Qaum)',
        text_en: '12th Class (General) / Alim-2nd Year (Dakhil) / Jalalain (Qaum)',
        text_bn: 'দ্বাদশ শ্রেণী (সাধারণ) / আলিম-২য় বর্ষ (দাখিল) / জালালাইন (কাওমি)'
    }
]

const studentGenderList = [
    {
        value: 1,
        text: 'Boy',
        text_en: 'Boy',
        text_bn: 'ছেলে'
    },
    {
        value: 2,
        text: 'Girl',
        text_en: 'Girl',
        text_bn: 'মেয়ে'
    },
    {
        value: 3,
        text: 'Others',
        text_en: 'Others',
        text_bn: 'অন্যান্য'
    }
]

const genderList = [
    { value: 1, text_en: 'Male', text_bn: 'পুরুষ' },
    { value: 2, text_en: 'Female', text_bn: 'মহিলা' }
]

const hospitalCategoryList = [
  {
      value: 1,
      text_en: 'General',
      text_bn: 'জেনারেল'
  },
  {
      value: 2,
      text_en: 'Burn Unit',
      text_bn: 'বার্ন ইউনিট'
  }
]

const diseaseList = [
    {
        value: 1,
        text_en: 'Cancer',
        text_bn: 'ক্যান্সার'
    },
    {
        value: 2,
        text_en: 'Kidney Disease',
        text_bn: 'কিডনী রোগ'
    },
    {
        value: 3,
        text_en: 'Liver Cirrhosis',
        text_bn: 'লিভার সিরোসিস'
    },
    {
        value: 4,
        text_en: 'Paralysis',
        text_bn: 'প্যারালাইসিস'
    },
    {
        value: 5,
        text_en: 'Heart Disease',
        text_bn: 'হৃদরোগ'
    },
    {
        value: 7,
        text_en: 'Leukemia',
        text_bn: 'লিউকেমিয়া'
    },
    {
        value: 6,
        text_en: 'Thalassemia',
        text_bn: 'থ্যালাসেমিয়া'
    }
]

const qoutaList = [
    {
        value: 1,
        text_en: 'Ministry Level (25%)',
        text_bn: 'মন্ত্রণালয় পর্যায়ে (২৫%)'
    },
    {
        value: 2,
        text_en: 'District Level (75%)',
        text_bn: 'জেলা পর্যায় (৭৫%)'
    }
]

const budgetTypeList = [
    { value: 1, text_en: 'District', text_bn: 'জেলা' },
    { value: 2, text_en: 'Office', text_bn: 'অফিস' },
    { value: 3, text_en: 'Hospital', text_bn: 'হাসপাতাল' }
]

const applicationTypeList = [
  {
      value: 1,
      text_en: 'Personal',
      text_bn: 'ব্যক্তিগত'
  },
  {
      value: 2,
      text_en: 'Anonymous',
      text_bn: 'বেনামী'
  }
]

const deliveryTypeList = [
    {
        value: 1,
        text_en: 'Deposit',
        text_bn: 'জমা'
    },
    {
        value: 2,
        text_en: 'Transfer',
        text_bn: 'স্থানান্তর'
    }
  ]

const publicServiceStatus = [
    {
        value: 1,
        text_en: 'Pending',
        text_bn: 'প্রক্রিয়াধীন'
    },
    {
        value: 2,
        text_en: 'Processing',
        text_bn: 'প্রক্রিয়াধীন'
    },
    {
        value: 3,
        text_en: 'Reviewed',
        text_bn: 'পর্যালোচনা'
    },
    {
        value: 4,
        text_en: 'Approved',
        text_bn: 'অনুমোদিত'
    },
    {
        value: 5,
        text_en: 'Disbursed',
        text_bn: 'বিতরণ'
    },
    {
        value: 6,
        text_en: 'Rejected',
        text_bn: 'প্রত্যাখ্যাত'
    }
]

const applicationStatusV2 = [
    {
        value: 1,
        text_en: 'Applied',
        text_bn: 'প্রয়োগ করা হয়েছে'
    },
    {
        value: 2,
        text_en: 'Application Applied',
        text_bn: 'আবেদন করা হয়েছে'
    },
    {
        value: 3,
        text_en: 'Pre Selected',
        text_bn: 'প্রাক নির্বাচিত'
    },
    {
        value: 4,
        text_en: 'Selected',
        text_bn: 'নির্বাচিত'
    },
    {
        value: 5,
        text_en: 'Board Approved',
        text_bn: 'বোর্ড অনুমোদিত'
    },
    {
        value: 6,
        text_en: 'Ministry Approved',
        text_bn: 'মন্ত্রণালয় অনুমোদিত'
    },
    {
        value: 7,
        text_en: 'Issued GEO',
        text_bn: 'জিও জারি করেছে'
    },
    {
        value: 8,
        text_en: 'Waiting',
        text_bn: 'অপেক্ষা করছে'
    },
    {
        value: 9,
        text_en: 'Rejected',
        text_bn: 'প্রত্যাখ্যাত'
    }
]

const expenseType = [
    { value: 1, text_bn: 'গ্রুপ', text_en: 'Group' },
    { value: 2, text_bn: 'ব্যক্তিগত', text_en: 'Individual' }
]

const beneficiaryType = [
    { value: 1, text_bn: 'ব্যক্তিগত', text_en: 'Individual', text: 'Individual' },
    { value: 2, text_bn: 'কমিটি', text_en: 'Committee', text: 'Committee' },
    { value: 3, text_bn: 'সংঘ', text_en: 'Association', text: 'Association' },
    { value: 4, text_bn: 'ইনস্টিটিউট', text_en: 'Institute', text: 'Institute' },
    { value: 5, text_bn: 'অফিস', text_en: 'Office', text: 'Office' }
]

const accountType = [
    { value: 1, text_bn: 'ব্যাংক হিসাব', text_en: 'Bank Account', text: 'Bank Account' },
    { value: 2, text_bn: 'এমএফএস', text_en: 'MFS', text: 'MFS' }
]

const bankAccountType = [
    { value: 1, text_bn: 'চলিত হিসাব', text_en: 'Current', text: 'Current' },
    { value: 2, text_bn: 'সঞ্চয়ী হিসাব', text_en: 'Saving', text: 'Saving' }
]

const mfsAccountType = [
    { value: 1, text_bn: 'বিকাশ', text_en: 'Bkash', text: 'Bkash' },
    { value: 2, text_bn: 'রকেট', text_en: 'Rocket', text: 'Rocket' },
    { value: 3, text_bn: 'নগদ', text_en: 'Nagad', text: 'Nagad' }
]

const budgetProcessList = [
    { value: 1, text_bn: 'অপেক্ষমাণ', text_en: 'Pending', text: 'Pending' },
    { value: 2, text_bn: 'প্রক্রিয়াধীন', text_en: 'Processing', text: 'Processing' },
    { value: 3, text_bn: 'অনুমোদিত', text_en: 'Approved', text: 'Approved' }
]

const noticeStatusList = [
    { value: 1, text_en: 'Pending', text_bn: 'যাচাই অধীন' },
    { value: 2, text_en: 'Circulated', text_bn: 'সারকুলেটেড' },
    { value: 3, text_en: 'Approved', text_bn: 'অনুমোদিত' },
    { value: 4, text_en: 'Rejected', text_bn: 'প্রত্যাখ্যাত' }
]

const statusList = [
    {
        value: 1,
        text_en: 'Paid',
        text_bn: 'পরিশোধিত'
    },
    {
        value: 2,
        text_en: 'Not Paid',
        text_bn: 'পরিশোধ করা হয়নি'
    }]

const applicationToList = [
    { value: 1, text_en: 'District', text_bn: 'জেলা' },
    { value: 2, text_en: 'Head Office', text_bn: 'সদর দফতর' }
]

const quarterList = [
    {
        value: 1,
        text_en: 'Quarter-1',
        text_bn: 'কোয়ার্টার-১',
        range_en: 'July to September',
        range_bn: 'জুলাই থেকে সেপ্টেম্বর'
    },
    {
        value: 2,
        text_en: 'Quarter-2',
        text_bn: 'কোয়ার্টার-২',
        range_en: 'October to December',
        range_bn: 'অক্টোবর থেকে ডিসেম্বর'
    },
    {
        value: 3,
        text_en: 'Quarter-3',
        text_bn: 'কোয়ার্টার-৩',
        range_en: 'January to March',
        range_bn: 'জানুয়ারী থেকে মার্চ'
    },
    {
        value: 4,
        text_en: 'Quarter-4',
        text_bn: 'কোয়ার্টার-৪',
        range_en: 'April to June',
        range_bn: 'এপ্রিল থেকে জুন'
    }
]

const inspectionSurvey = [
    { value: 1, text_en: 'Yes', text_bn: 'হ্যাঁ' },
    { value: 2, text_en: 'No', text_bn: 'না' }
]

const nomineeRelationList = [
    { value: 1, text_en: 'Father', text_bn: 'পিতা' },
    { value: 2, text_en: 'Mother', text_bn: 'মাতা' },
    { value: 3, text_en: 'Husband', text_bn: 'স্বামী' },
    { value: 4, text_en: 'Wife', text_bn: 'স্ত্রী' },
    { value: 5, text_en: 'Brother', text_bn: 'ভাই' },
    { value: 6, text_en: 'Sister', text_bn: 'বোন' },
    { value: 7, text_en: 'Son', text_bn: 'ছেলে' },
    { value: 8, text_en: 'Daughter', text_bn: 'মেয়ে' },
    { value: 9, text_en: 'Grand-son', text_bn: 'নাতী' },
    { value: 10, text_en: 'Grand-daughter', text_bn: 'নাতনী' },
    { value: 11, text_en: 'Legal Guardian', text_bn: 'বৈধ অভিভাবক' }
]
const formTypeList = [
    {
        value: 1,
        text_en: 'Application form for receiving special grant for disabled students/poor and meritorious students',
        text_bn: 'প্রতিবন্ধী শিক্ষার্থী/দরিদ্র মেধাবী শিক্ষার্থীর বিশেষ অনুদান প্রাপ্তির আবেদন ফরম'
    },
    {
        value: 2,
        text_en: 'Application form for receiving special grants for distressed, helpless, sick, disabled, homeless individuals or organizations',
        text_bn: 'দুস্থ, অসহায়, অসুস্থ, প্রতিবন্ধী, গৃহহীন ব্যক্তি বা সংগঠনের বিশেষ অনুদান প্রাপ্তির আবেদন ফরম'
    }
]

export default {
  productTypeLists,
  serviceTypeList,
  splCategoryList,
  burnPatientTypeList,
  hospitalCategoryList,
  diseaseList,
  qoutaList,
  budgetTypeList,
  applicationTypeList,
  healthConditionList,
  studyingClassList,
  installmentList,
  studentClassList,
  studentGenderList,
  genderList,
  publicServiceStatus,
  expenseType,
  beneficiaryType,
  accountType,
  bankAccountType,
  mfsAccountType,
  budgetProcessList,
  noticeStatusList,
  deliveryTypeList,
  statusList,
  applicationToList,
  applicationStatusV2,
  quarterList,
  inspectionSurvey,
  nomineeRelationList,
  formTypeList
}
